import { render, staticRenderFns } from "./daily-quotation-sheet.vue?vue&type=template&id=08bcc62f&scoped=true&"
import script from "./daily-quotation-sheet.vue?vue&type=script&lang=js&"
export * from "./daily-quotation-sheet.vue?vue&type=script&lang=js&"
import style0 from "./daily-quotation-sheet.vue?vue&type=style&index=0&id=08bcc62f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bcc62f",
  null
  
)

export default component.exports